import { RECEIVE_EMPLOYMENT_SUMMARY, REQUEST_EMPLOYMENT_SUMMARY } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_EMPLOYMENT_SUMMARY:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_EMPLOYMENT_SUMMARY: {
            return { ...state, ...data, isFetching: false }
        }

        default:
            return state
    }
}
